import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSetKycData } from 'context';
import { MixpanelTrackEvent } from 'context/Mixpanel';
import { SignInSuccessData } from 'hooks/login/api';
import { useOnrampData, useSetOnrampData } from 'onramp-pages/context';

export const useHandleSuccessSignIn = ({
  mixpanelTrackEvent,
}: {
  mixpanelTrackEvent: MixpanelTrackEvent;
}) => {
  const navigate = useNavigate();
  const setkyc = useSetKycData();
  const { email } = useOnrampData();
  const setOnrampData = useSetOnrampData();

  const handleRedirect = useCallback(
    (data: SignInSuccessData) => {
      const {
        kyc: { actions },
        requestConsent,
      } = data;
      const { kyc } = data;

      mixpanelTrackEvent('Login completed', {
        description: 'User completed the login process.',
        accountStatus: kyc.accountStatus,
      });

      switch (kyc.accountStatus) {
        case 'PENDING_CLOSURE':
          return navigate('/onramp/account-on-hold');
        case 'BLOCKED':
          return navigate('/onramp/account-blocked');
        case 'CLOSED':
          return navigate('/onramp/account-closed');
      }

      if (!('email' in kyc) && email) {
        kyc.email = { address: email, verified: false };
      }

      setkyc({ ...kyc });
      setOnrampData({ autoProcess: true });

      if (requestConsent) return navigate('/onramp/onboarding/consent');

      if (
        actions.some(
          (action) => action.status !== 'APPROVED' && action.isRequired
        )
      ) {
        return navigate('/onramp/onboarding/steps');
      }

      return navigate('/onramp');
    },
    [navigate, setkyc, email, mixpanelTrackEvent, setOnrampData]
  );

  return handleRedirect;
};
